import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { EnvService } from "@app/shared/services/env.service";

@Injectable({
  providedIn: "root",
})
export class TrainingVerifyService {
  private baseUrl: string;
  private headers: HttpHeaders;

  constructor(private http: HttpClient, private envService: EnvService) {
    this.baseUrl = `${this.envService.apiUrl}/cpapi`;
    const token = localStorage.getItem("id_token");
    this.headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
  }

  getTrainingVerifyData(trainingId: number): Observable<any> {
    const traineeRaw = localStorage.getItem("trainee");
    let traineeId = 0;

    if (traineeRaw) {
      try {
        const traineeObj = JSON.parse(traineeRaw);
        traineeId = traineeObj.trainee_id;
      } catch (e) {
        console.error("Invalid trainee object in localStorage", e);
      }
    }

    return this.http.get(
      `${this.baseUrl}/getTrainingVerifyData?training_id=${trainingId}&trainee_id=${traineeId}`,
      { headers: this.headers }
    );
  }

  saveCommentTrainingVerifyData(body: {
    quiz_trainee_id: number;
    comment: string;
  }): Observable<any> {
    let traineeIdManagerVerify = 0;

    const traineeRaw = localStorage.getItem("trainee");
    if (traineeRaw) {
      try {
        const traineeObj = JSON.parse(traineeRaw);
        traineeIdManagerVerify = traineeObj.trainee_id;
      } catch (e) {
        console.error("Invalid trainee object in localStorage", e);
      }
    }

    const payload = {
      ...body,
      trainee_id_manager_verify: traineeIdManagerVerify,
    };

    return this.http.post(
      `${this.baseUrl}/saveCommentTrainingVerifyData`,
      payload,
      { headers: this.headers }
    );
  }

  saveTrainingVerifyData(body: {
    quiz_trainee_id: number;
    trainee_id_manager_verify: number;
    quiz_question_answer_id: number;
    quiz_question_answer_level: string;
  }): Observable<any> {
    return this.http.post(`${this.baseUrl}/saveTrainingVerifyData`, body, {
      headers: this.headers,
    });
  }

  submitTrainingVerifyData(body: {
    training_id: number;
    course_task_id: number;
    trainee_id_manager_verify: number;
  }) {
    return this.http.post(`${this.baseUrl}/submitTrainingVerifyData`, body, {
      headers: this.headers,
    });
  }
}
